/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { OperationType } from 'relay-runtime';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type TopNavEntryPointComponent = EntryPointComponent<
	Record<string, OperationType>,
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	Record<string, EntryPoint<any, any> | undefined>,
	{},
	{} | null
>;

export const topNavEntryPoint: EntryPoint<TopNavEntryPointComponent, {}> = createEntryPoint({
	root: JSResourceForUserVisible<TopNavEntryPointComponent>(
		/* webpackChunkName: "async-atlassian-navigation" */ './ui/TopNavigation.tsx',
		{
			includeInShellOnlySsrBundle: true,
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: () => ({}),
});
